<template>
	<div class="col-lg-auto">
        <div class="tiny--widget">
            <div class="card card-body">
                <!-- Row -->
                <div class="row">
                    <!-- Column -->
                    <div class="col pr-0 align-self-center">
                        <h1 style="font-size: 30px" class="font-weight-light mb-0">{{this.value}}</h1>
                        <h6 class="text-muted">{{this.title}}</h6>
                    </div>
                    <!-- Column -->
                    <div class="col text-right align-self-center">
                        <div data-label="20%" class="css-bar mb-0 css-bar-info css-bar-20"></div>
                    </div>
                </div>
            </div>
            <div :class="getClass()">
                <div class="row align-items-center">
                    <div class="col-9">
                        <p class="text-white m-b-0">{{this.subtitle}}</p>
                    </div>
                    <div class="col-3 text-right">
                        <i class="feather icon-trending-up text-white f-16"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

	export default {
		data () {
	      return {
	      	colors: {
	      		"Recruiting": "bg-c-hrtgreen",
	      		"People & Organization": "bg-c-englishgreen",
	      		"Learning": "bg-c-blue",
	      		"Talent & Performance": "bg-c-amaranthred",
	      		"Safety": "bg-c-tennesseeorange",
	      	},
	      	endPoint: this.url,
	      	widgetTitle: this.title,
	      	widgetSubtitle: this.subtitle,
	      	value: 0
	      }
	  	},
        mounted() {

        	this.fetchDatas(this.endPoint);
        },
        methods: {
        	fetchDatas(endPoint) {
        		let thiz = this;
        		axios.get(endPoint)
  				.then((response) => {
  					thiz.value = response.data.value;
  				});
        	},
            changeUrl(newUrl) {
                this.url = newUrl;
                this.fetchDatas(newUrl);
            },
        	getClass() {
        		return "card-footer "+this.colors[this.subtitle];
        	}
        },
        props: {
            url: {
                type: String,
                required : true
            },
            title: {
                type: String,
                required : false
            },
            subtitle: {
                type: String,
                required : false
            }
        },
    }


</script>
